export const codeArr = [
{
        code : `int x = 5;
int result = ++x;
printf("%d\\n", result); // Output: 6
printf("%d\\n", x); // Output: 6`
    },

    {
        code : `int x = 5;
int result = x++;
printf("%d\\n", result); // Output: 5
printf("%d\\n", x); // Output: 6`
    },

    {
        code : `int x = 5;
int result = --x;
printf("%d\\n", result); // Output: 4
printf("%d\\n", x); // Output: 4`
    },

    {
        code : `int x = 5;
int result = x--;
printf("%d\\n", result); // Output: 5
printf("%d\\n", x); // Output: 4`
    },
];